<template>
    <UPageSection
        v-if="resolvedImages.length"
        :ui="{ container: '' }"
    >
        <div
            :class="gridColsClass"
            class="grid grid-cols-1 gap-4 sm:gap-4"
        >
            <NuxtImg
                v-for="image in resolvedImages"
                :key="image.key"
                :alt="image.alt"
                :src="image.src"
                class="size-full object-cover bg-white object-center max-h-130 rounded-lg drop-shadow-lg"
                format="webp"
                sizes="100vw lg:33vw"
            />
        </div>
    </UPageSection>
</template>

<script setup lang="ts">
import type {PropType} from 'vue';
import type {Media} from '~~/types/strapi-blog';

type BannerItem = { image?: Media | null }

const props = defineProps({
    bannerImages: {type: Array as PropType<BannerItem[]>, default: () => []},
});

const resolvedImages = computed(() => props.bannerImages
    .map((item, index) => ({
        key: item.image?.documentId ?? `${item.image?.url ?? 'image'}-${index}`,
        src: item.image?.url ? useStrapiMedia(item.image.url) : null,
        alt: item.image?.alternativeText ?? '',
    }))
    .filter((img) => Boolean(img.src)));

const gridColsClass = computed(() => {
    const count = Math.min(4, resolvedImages.value.length);
    if (count === 1) {
        return 'sm:grid-cols-1';
    }
    if (count === 2) {
        return 'sm:grid-cols-2';
    }
    if (count === 3) {
        return 'sm:grid-cols-3';
    }
    return 'sm:grid-cols-4';
});
</script>

<style scoped>

</style>
